import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import Testimonial from "./Testimonial";
import Newsletter from "./NewsLetter";
import OurTeam from "./OurTeam";

const Home = () => {
  return (
    <>
      <div id="rapid-home" className="page"></div>
      <Header />

      <h1
        className="contact-bg pt-0 text-light  text-uppercase  text-center  fw-bold col-md-12 col-lg-12 col-sm-12 "
        style={{
          fontSize: "3rem",
          letterSpacing: "2px",
          borderBottom: "7px solid gold",
        }}
      >
        Rapid Lab & Diagnostics center <sup>&reg;</sup>
      </h1>

      {/* <!-- Welcome to Rapid Lab? --> */}
      <section
        className="main-section px-0 pt-5 col-12 bg-warning-subtle "
        style={{ scrollMarginTop: "80px" }}
      >
        <div className="card fly-in rounded-5 glass-morph text-center col-lg-5 col-sm-9  col-md-8 m-2 p-3  ">
          <h3 className="card-title pt-1 text-primary-emphasis pt-0 text-center fs-1 fw-bolder col-md-12 col-lg-12 col-sm-12">
            Rapid Lab & Diagnostics
          </h3>
          <p className="fs-6 col-lg-8 fw-medium  mx-auto">
            Where modern technology and expert care come together for better
            diagnostics.
          </p>
          <div className="card-text text-secondary-emphasis col-sm-10 col-md-12 mx-auto  text-start col-lg-12 fs-3 fw-medium pt-0 ">
            Get clear answers about your health in just hours. With most tests
            processed on-site, you enjoy faster results, expert guidance, and
            the option to share them with your doctor or keep for your personal
            records.
            <div className="pt-0 mt-0">
              <Link
                className="link-warning  text-primary-emphasis link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover fw-semibold fs-4"
                to="/about-us"
              >
                Learn More
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="60"
                  height="30"
                  fill="#000080"
                  className="bi bi-arrow-right"
                  viewBox="0 0 19 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                  />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-img pt-5">
        {/* <!-- location, services, facilities  --> */}
        <section className=" d-flex flex-column flex-md-row  gap-2 fly-in-top ">
          {/* <!-- card 1 --> */}
          <div
            className="card  text-bg-light text-dark mb-2 col-sm-12 col-lg-4 col-md-4"
            style={{ maxwidth: "50rem", maxHeight: "50rem" }}
          >
            <div className="d-flex justify-content-center p-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                fill="#052c65"
                className="bi bi-geo-alt-fill"
                viewBox="0 0 16 16"
              >
                <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
              </svg>
            </div>
            <div className="card-header fs-4 fw-bolder text-center text-primary-emphasis ">
              <h2>Our Location</h2>
            </div>
            <div className="card-body text-start col-9 col-lg-9 m-auto">
              <p className="card-text fw-medium text-primary-emphasis">
                <strong>Tema Community 9,</strong> Opposite Tema General
                Hospital
                <br />
                Tema, Ghana
              </p>
              <div className="">
                {" "}
                <a
                  href="https://maps.app.goo.gl/hsW6hfC3x8752dZg6"
                  target="_blank"
                  rel="noreferrer"
                  className="link-primary text-primary-emphasis link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover fw-semibold fs-4"
                >
                  Get Directions
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="50"
                      height="30"
                      fill="#052c65"
                      className="bi bi-arrow-right"
                      viewBox="0 0 19 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                      />
                    </svg>
                  </span>{" "}
                </a>
              </div>
            </div>
          </div>
          {/* <!-- card 2 --> */}
          <div
            className="card text-bg-warning mb-2 col-sm-12  col-md-4 "
            style={{ maxWwidth: "50rem" }}
          >
            <div className="d-flex justify-content-center p-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                fill="currentColor"
                className="bi bi-house-gear"
                viewBox="0 0 16 16"
              >
                <path d="M7.293 1.5a1 1 0 0 1 1.414 0L11 3.793V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.293l2.354 2.353a.5.5 0 0 1-.708.708L8 2.207l-5 5V13.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 2 13.5V8.207l-.646.647a.5.5 0 1 1-.708-.708z" />
                <path d="M11.886 9.46c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.044c-.613-.181-.613-1.049 0-1.23l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382zM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0" />
              </svg>
            </div>
            <div className="card-header fs-4 fw-bolder text-center">
              <h2>Our Services</h2>
            </div>
            <div className="card-body m-auto col-9">
              <div className="card-text fw-medium fs-6">
                Our Services include:
                <ul>
                  <li>X-ray Analysis</li>
                  <li>UltraSound</li>
                  <li>Imaging</li>
                </ul>
              </div>

              <div>
                {""}
                <Link
                  to="/services"
                  className="link-dark link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover fw-semibold fs-4"
                >
                  {" "}
                  Learn More{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="60"
                    height="30"
                    fill="dark"
                    className="bi bi-arrow-right"
                    viewBox="0 0 19 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                    />
                  </svg>{" "}
                </Link>
              </div>
            </div>
          </div>
          {/* <!-- card 3 --> */}
          <div
            className="card contact-bg text-light   mb-2 col-sm-12  d-flex justify-content-center col-md-4"
            style={{ maxWidth: "50rem" }}
          >
            <div className="d-flex justify-content-center p-2">
              {" "}
              <img
                loading="lazy"
                style={{ width: "50px", height: "50px" }}
                src="/images/assets/noun-facility-management-7153235 copy.png"
                alt=""
              />
            </div>
            <div className="card-header fs-4 fw-bolder text-center ">
              <h2> Our Facilities</h2>
            </div>
            <div className="card-body m-auto">
              <p className="card-title fw-medium m-auto">
                We believe in leveraging technology to create an enhanced
                healthcare experience and convinience using our latest
                cutting-edge equipment.
              </p>

              <div className="">
                {"  "}
                <Link
                  to="/facilities#facilities"
                  className="link-light link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover fw-semibold fs-4"
                >
                  {" "}
                  Learn More{"  "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="60"
                    height="30"
                    fill="white"
                    className="bi bi-arrow-right"
                    viewBox="0 0 19 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                    />
                  </svg>{" "}
                </Link>
              </div>
            </div>
          </div>
        </section>
      </section>

      {/* Why choose Us */}
      <section className="pt-5 m-auto">
        <div className="card border-0 ">
          <div className="d-lg-flex col-12">
            <div className="col-md-7">
              <div className="card-body col-lg-12 col-sm-12 col-md-12 px-4 pt-3 mt-3">
                <h2 className=" text-start pt-1  fw-semibold text-primary-emphasis">
                  Why Choose Us
                </h2>
                <h3 className=" text-warning ">
                  <span className=" text-decoration-underline">
                    Rapid Testing
                  </span>{" "}
                  <span className="text-primary-emphasis fs-1">A to Z</span>
                </h3>
                <p className="text-primary-emphasis fw-semibold fs-6 ">
                  We've introduced a number of tests, and many have become the
                  official standard of medical care.
                </p>

                <ul className="p-0  m-0 ">
                  <li className="list-unstyled  ">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      fill="#ffc107"
                      className="bi bi-check-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                    </svg>
                    <span className="text-primary-emphasis fs-6 fw-semibold ">
                      {" "}
                      A wide range of laboratory test
                    </span>
                  </li>
                  <li className="list-unstyled  pt-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      fill="#ffc107"
                      className="bi bi-check-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                    </svg>
                    <span className="text-primary-emphasis fs-6 fw-semibold ">
                      {" "}
                      Ultramodern equipment
                    </span>
                  </li>
                  <li className="list-unstyled pt-3 ">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      fill="#ffc107"
                      className="bi bi-check-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                    </svg>
                    <span className="text-primary-emphasis fs-6 fw-semibold">
                      {" "}
                      High safety standards
                    </span>
                  </li>
                  <li className="list-unstyled pt-3 ">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      fill="#ffc107"
                      className="bi bi-check-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                    </svg>
                    <span className="text-primary-emphasis fs-6 fw-semibold px-2">
                      {""}
                      Quick Turnaround Time
                    </span>
                  </li>
                  <li className="list-unstyled pt-3 ">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      fill="#ffc107"
                      className="bi bi-check-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                    </svg>
                    <span className="text-primary-emphasis fs-6 fw-semibold px-2">
                      {""}
                      Mobile concierge & drive-through phlebotomy Services
                    </span>
                  </li>
                  <li className="list-unstyled pt-3 ">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      fill="#ffc107"
                      className="bi bi-check-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                    </svg>
                    <span className="text-primary-emphasis fs-6 fw-semibold px-2">
                      {""}
                      Qualified Staff
                    </span>
                  </li>
                  <br />
                  <Link
                    className="link-warning  text-primary-emphasis link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover fw-semibold fs-6"
                    to="/services"
                  >
                    Learn More
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="60"
                      height="30"
                      fill="#000080"
                      className="bi bi-arrow-right"
                      viewBox="0 0 19 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                      />
                    </svg>
                  </Link>
                </ul>
              </div>
            </div>
            <div className=" ">
              <img
                loading="lazy"
                className="pt-0 mt-0 px-1 img-fluid img-thumbnail rounded col-sm-12 col-md-12 col-lg-12"
                src="images/assets/rapid-woman-smiling.jpeg"
                alt="rapid-woman-smiling"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section>
        <hr className="border border-scondary-emphasis border-2 opacity-50  " />
        <Testimonial />
      </section>

      <section>
        <OurTeam />
      </section>
      {/* <!-- Frequently Asked questions --> */}
      <section className="pt-5 col-sm-12">
        <h2 id="F&Q" className="text-primary-emphasis text-center">
          Frequently Asked Questions
        </h2>
        <hr className="bg-dark" />
        {/* <!-- Accordion --> */}
        <div className="col-md-11 col-lg-12 col-sm-12 container pb-2 mb-2 ">
          <div className="accordion" id="accordionExample">
            {/* <!-- -----------------Accordion Item 1------------------ --> */}
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed text-primary-emphasis fs-6 fw-semibold"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  HOW DO I PREPARE FOR AN ULTRASOUND ?
                </button>
              </h2>
              <div
                id="collapseOne"
                className="accordion-collapse collapse "
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body fs-6 fw-normal text-primary-emphasis">
                  The preparations for an ultrasound vary depending on the body
                  part you are having scanned. For studies involving the liver,
                  gallbladder (the gallbladder contracts when food is digesting,
                  so it is very important to follow these directions so the
                  entire gallbladder can be visualized), spleen and pancreas,
                  eat an early low-fat dinner on the night before your exam and
                  have nothing to eat or drink for eight to 12 hours prior to
                  your exam. For studies of your pelvis, you will need to have a
                  full bladder for this exam. Please drink six eight oz. glasses
                  of liquid. Finish drinking this liquid one hour prior to your
                  exam. Do Not Empty your bladder before the exam. For studies
                  of your Kidneys, you may be asked to drink four to six glasses
                  of liquid one hour prior to your exam so that your bladder can
                  be visualized. For studies involving your aorta, please avoid
                  eating for 8 to 12 hours prior to your exam. There is no
                  preparation if you are having an ultrasound of your Breast,
                  Extremity or other body parts (i.e., Thyroid).
                </div>
              </div>
            </div>

            {/* <!-- -----------------Accordion Item 2------------------ --> */}
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed text-primary-emphasis fs-6 fw-semibold"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="true"
                  aria-controls="collapseTwo"
                >
                  WHAT SHOULD I WEAR FOR MY ULTRASOUND ?
                </button>
              </h2>
              <div
                id="collapseTwo"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body fs-6 fw-normal text-primary-emphasis">
                  You should wear comfortable, loose-fitting clothing for your
                  ultrasound exam. You may need to remove all clothing and
                  jewelry in the area to be examined. Depending on the procedure
                  you may be asked to wear a gown during the procedure.
                </div>
              </div>
            </div>

            {/* <!-- -----------------Accordion Item 3------------------ --> */}
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed text-primary-emphasis fs-6 fw-semibold"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseThree"
                  aria-expanded="true"
                  aria-controls="collapseThree"
                >
                  WHAT HAPPENS DURING AN ULTRASOUND ?
                </button>
              </h2>
              <div
                id="collapseThree"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body fs-6 fw-normal text-primary-emphasis">
                  For most ultrasound exams, you are normally asked to lie down
                  on a comfortable exam table where the area to be examined is
                  exposed while the rest of the body is covered.
                  <p>
                    After you are positioned on the table, our certified
                    sonographer will apply a warm water-based gel to the area of
                    the body being studied. The sonographer will use a small
                    handheld device called a transducer, which is approximately
                    the size of a bar of soap to complete the exam. Then the
                    sonographer places the transducer on the body and gently
                    moves it back and forth over the area of interest until the
                    desired images are captured. There is usually no discomfort
                    during the exam when the transducer is pressed against the
                    area being examined. Once the imaging is complete, the
                    water-based gel will be wiped off your skin, and any
                    portions that are not wiped off will dry to a powder. The
                    ultrasound gel does not stain or discolor clothing.
                  </p>
                </div>
              </div>
            </div>

            {/* <!-- -----------------Accordion Item 4------------------ --> */}
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed text-primary-emphasis fs-6 fw-semibold"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFour"
                  aria-expanded="true"
                  aria-controls="collapseThree"
                >
                  WHAT HAPPENS AFTER THE ULTRASOUND?
                </button>
              </h2>
              <div
                id="collapseFour"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body fs-6 fw-normal text-primary-emphasis">
                  You will be free to leave the facility and resume normal
                  activities as your health permits. A radiologist reads your
                  MRI, and the results are reported directly back to your
                  doctor.
                </div>
              </div>
            </div>

            {/* <!-- -----------------Accordion Item 5------------------ --> */}
            <div className="accordion-item " id="x-ray">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed text-primary-emphasis fs-6 fw-semibold"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseSix"
                  aria-expanded="true"
                  aria-controls="collapseSix"
                >
                  HOW DO X-RAYS WORK ?
                </button>
              </h2>
              <div
                id="collapseSix"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body fs-6 fw-normal text-primary-emphasis">
                  Radiography involves exposing a part of the body to a small
                  dose of ionizing radiation to produce pictures of the inside
                  of the body. Different parts of the body absorb the X-rays in
                  varying degrees. Dense bone absorbs much of the radiation
                  while soft tissue, such as muscle, fat and organs, allow more
                  of the x-rays to pass through them. As a result, bones appear
                  white on the X-ray, soft tissue shows up in shades of gray,
                  and air appears black. a doctor attending to a patient adult a
                  white glove on a black surface a close-up of a white machine
                  Find A Touchstone Imaging center offering X-ray appointments
                  near you!
                </div>
              </div>
            </div>

            {/* <!-- -----------------Accordion Item 6------------------ --> */}
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed text-primary-emphasis fs-6 fw-semibold"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseSeven"
                  aria-expanded="true"
                  aria-controls="collapseSeven"
                >
                  WHY THE NEED FOR AN X-RAY ?
                </button>
              </h2>
              <div
                id="collapseSeven"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body fs-6 fw-normal text-primary-emphasis">
                  X-rays can be used to image every part of the body and are
                  used most often to look for fractures. They are also commonly
                  used to examine the chest, abdomen, and superficial soft
                  tissues. X-rays can identify many different conditions, and
                  they are often a fast and easy method for your doctor to make
                  a diagnosis.
                </div>
              </div>
            </div>

            {/* <!-- -----------------Accordion Item 7------------------ --> */}
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed text-primary-emphasis fs-6 fw-semibold"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseEight"
                  aria-expanded="true"
                  aria-controls="collapseEight"
                >
                  DO YOU ACCEPT NATIONAL HEALTH INSURANCE ?
                </button>
              </h2>
              <div
                id="collapseEight"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body fs-6 fw-normal text-primary-emphasis">
                  Yes, we accept national health insurance. Please contact us
                  for more information.{" "}
                </div>
              </div>
            </div>

            {/* <!-- -----------------Accordion Item 8------------------ --> */}
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed text-primary-emphasis fs-6 fw-semibold"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseNine"
                  aria-expanded="true"
                  aria-controls="collapseNine"
                >
                  CAN I CANCEL MY LAB TEST ORDER ?
                </button>
              </h2>
              <div
                id="collapseNine"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body fs-6 fw-normal text-primary-emphasis">
                  You may cancel your order any time before the visit. Please
                  contact us by phone to cancel your order.
                </div>
              </div>
            </div>

            {/* <!-- -----------------Accordion Item 8------------------ --> */}
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed text-primary-emphasis fs-6 fw-semibold"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTen"
                  aria-expanded="true"
                  aria-controls="collapseTen"
                >
                  CAN YOU SEND THE TEST RESULT TO MY DOCTOR ?
                </button>
              </h2>
              <div
                id="collapseTen"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body fs-6 fw-normal text-primary-emphasis">
                  Sure, we'll send the results as soon as we get them, if you
                  want. In this case, specify the email of your doctor or the
                  post address.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* News letter */}
      <Newsletter />
      <Footer />
    </>
  );
};
export default Home;
